
























































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import moment from "moment";
import VueRouter, { Location } from "vue-router";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import Pagination from "@/shared/components/ui/Pagination.vue";
import { UserPermission } from "@/shared/types";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import { usePartnerStore } from "@/admin/store/partner";


@Component({
  components: {
    Button,
    Pagination
  }
})
export default class Partners extends Vue {
  $router: VueRouter;
  $validator: Validator;

  rolePermissionsStore = useRolePermissionsStore();
  partnerStore = usePartnerStore();

  @Prop() pageNumber: number;

  @Prop() routeToPartnerList: (pageNumber: number) => Location;

  created (): void {
    this.partnerStore.reload();
  }

  formatDate (date?: moment.Moment) {
    if (!date) {
      return "";
    }

    return date.format("MM/DD/YYYY");
  }

  onPageChanged (pageNumber: number): void {
    this.$router.push(this.routeToPartnerList(pageNumber));
  }

  @Watch("pageNumber")
  onRouteValuePageNumberChanged () {
    this.partnerStore.setPageNumber(this.pageNumber);
  }

  get hasEditPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit);
  }

  get hasViewPermission (): boolean {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerEdit) ||
      this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalPartnerView);
  }
}
